// import React, { useState, useEffect } from 'react';
// import { Helmet } from 'react-helmet';
// import { Link } from 'react-router-dom';
// import FAQSchema from '../../FAQSchema';
// import AdBanner from '../AdPage/AdBanner';

// const GratuityCalculator = () => {
//   const [salary, setSalary] = useState(60000);
//   const [yearsOfService, setYearsOfService] = useState(20);
//   const [gratuity, setGratuity] = useState(0);

//   useEffect(() => {
//     calculateGratuity(salary, yearsOfService);
//   }, [salary, yearsOfService]);

//   const calculateGratuity = (salary, yearsOfService) => {
//     const gratuity = (salary * 15 * yearsOfService) / 26;
//     setGratuity(gratuity.toFixed(2));
//   };

//   const handleSalaryChange = (e) => {
//     const value = e.target.value === '' ? 0 : parseInt(e.target.value);
//     setSalary(value);
//   };

//   const handleYearsOfServiceChange = (e) => {
//     const value = e.target.value === '' ? 0 : parseInt(e.target.value);
//     setYearsOfService(value);
//   };
// function Icon({ id, open }) {
//     return (
//         <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             strokeWidth={2}
//             stroke="currentColor"
//             className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
//         >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
//         </svg>
//     );
//   }
  
  
//     const [activeIndex, setActiveIndex] = useState(0);
  
     
//     const faqs = [
//       {
//         question: 'What is the minimum service period required for gratuity?',
//         answer: 'An employee must complete 5 years of continuous service to be eligible for gratuity, except in cases of death or permanent disability.',
//       },
//       {
//         question: 'Is gratuity applicable to private company employees?',
//         answer: 'Yes, gratuity is applicable if the company employs 10 or more people on any day in the preceding 12 months.',
//       },
//       {
//         question: 'Is my entire salary considered for gratuity calculation?',
//         answer: 'No, only your basic salary and dearness allowance (DA) are considered for calculating gratuity.',
//       },
//       {
//         question: 'Can I receive gratuity if I resign before completing 5 years?',
//         answer: 'Generally, no. However, in the event of death or permanent disability, the 5-year condition is waived.',
//       },
//       {
//         question: 'Is gratuity taxable?',
//         answer: 'Gratuity is tax-free up to ₹20 lakhs for non-government employees under current income tax rules.',
//       },
//       {
//         question: 'How is gratuity calculated for more than 6 months in a year?',
//         answer: 'If the final year of service exceeds 6 months, it is rounded up and considered a full year for calculation.',
//       },
//       {
//         question: 'Can contractual employees receive gratuity?',
//         answer: 'Yes, if they are employed directly by the company and are on its payroll.',
//       },
//       {
//         question: 'What happens to gratuity if an employee dies during service?',
//         answer: 'The legal heir or nominee is entitled to receive the gratuity, regardless of the employee’s length of service.',
//       },
//       {
//         question: 'Can gratuity be forfeited?',
//         answer: 'Yes, gratuity can be partially or fully forfeited in cases of proven misconduct, theft, or fraud.',
//       },
//       {
//         question: 'Do startups offer gratuity?',
//         answer: 'Yes, startups with 10 or more employees are legally required to offer gratuity if other eligibility criteria are met.',
//       },
//       {
//         question: 'Is there a maximum limit for gratuity?',
//         answer: 'Yes, the maximum tax-free gratuity amount is ₹20 lakhs. Employers may pay more, but the excess is taxable.',
//       },
//       {
//         question: 'Can I calculate gratuity if I worked for multiple companies?',
//         answer: 'Gratuity is calculated per employer. You need to complete 5 years of service with each employer to qualify.',
//       },
//       {
//         question: 'Does leave encashment affect gratuity?',
//         answer: 'No, leave encashment is a separate component and does not impact gratuity calculation.',
//       },
//       {
//         question: 'Will future inflation affect gratuity amount?',
//         answer: 'No, gratuity is calculated based on your last drawn salary, not future inflation or expected salary hikes.',
//       },
//       {
//         question: 'Can I negotiate gratuity at the time of joining?',
//         answer: 'No, gratuity is a statutory benefit mandated by law and not open to negotiation during hiring.'
//       },
//     ];
//     const toggleAccordion = (index) => {
//       if (activeIndex === index) {
//           // If the clicked question is already expanded, collapse it
//           setActiveIndex(null);
//       } else {
//           // If the clicked question is not expanded, expand it
//           setActiveIndex(index);
//       };
//     }
//   return (
//     <>
//      <Helmet>
//          <title>Gratuity Calculator – Calculate Gratuity Amount Online</title>
//         <meta  name='description' content='Use our gratuity calculator to estimate your gratuity payout as per Indian labor laws. Fast and easy.'/>
//         <meta name='keywords' content='gratuity calculator, retirement gratuity calculation formula, calculation of gratuity for central government employees, calculation of gratuity for private employees, dcrg calculation' />
//         <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/gratuity-calculator" />
//         <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
//         <meta name="robots" content="max-video-preview:-1" />
//       </Helmet>
//       <FAQSchema faqs={faqs} />
//       {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
//       <ol className="list-none p-0 inline-flex">
//         <li className="flex items-center">
//           <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
//           <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//           </svg>
//         </li>
//         <li className="flex items-center">
//           <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
//           <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
//             <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
//           </svg>
//         </li>
//           <li className="flex items-center">
//           <span className="text-gray-500 ">Gratuity Calculator</span>
//         </li> 
      
//       </ol>
//     </nav> */}
//           <div className="w-full flex justify-center items-center px-4 mt-20">
//   <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
//   <AdBanner displayOrder="1" />
//   </div>
// </div>
// <div className='py-4 '>


//     <div className="container mx-auto p-4 max-w-7xl  ">
//       <div className="flex flex-wrap -mx-4">
//         <div className="w-full lg:w-2/3 px-4">
         
//           <div className="bg-white  p-6 shadow-md rounded-md">
//           <h2 className="text-2xl font-bold mb-4">Gratuity Calculator</h2>
//             <div className="mb-4">
//               <label className="block text-gray-700 font-semibold">Monthly salary (Basic + DA)</label>
//               <div className="flex items-center">
//                 <input
//                   type="number"
//                   min="0"
//                   value={salary}
//                   onChange={handleSalaryChange}
//                   className="w-1/2 p-2 border rounded mr-2"
//                 />
//                 <span className="text-gray-700">₹ {salary.toLocaleString()}</span>
//               </div>
//               <input
//                 type="range"
//                 min="0"
//                 max="1000000"
//                 value={salary}
//                 onChange={(e) => setSalary(parseInt(e.target.value))}
//                 className="w-full mt-2"
//               />
//             </div>
//             <div className="mb-4">
//               <label className="block text-gray-700 font-semibold">Years of service</label>
//               <div className="flex items-center">
//                 <input
//                   type="number"
//                   min="0"
//                   max="50"
//                   value={yearsOfService}
//                   onChange={handleYearsOfServiceChange}
//                   className="w-1/2 p-2 border rounded mr-2"
//                 />
//                 <span className="text-gray-700">{yearsOfService} years</span>
//               </div>
//               <input
//                 type="range"
//                 min="0"
//                 max="50"
//                 value={yearsOfService}
//                 onChange={(e) => setYearsOfService(parseInt(e.target.value))}
//                 className="w-full mt-2"
//               />
//             </div>
//             <div className="mt-4 text-center">
//               <h2 className="text-xl font-bold">Total Gratuity payable</h2>
//               <p className="text-3xl text-gray-800">₹ {gratuity.toLocaleString()}</p>
//             </div>
//           </div>
//         </div>
//         <div className="w-full lg:w-1/3 px-6 mt-8 lg:mt-0 text-center">
//           <div className="bg-white p-6 shadow-md rounded-md">
//             <h2 className="text-xl font-bold mb-4 text-center">Invest the way you want</h2>
//             <img src='https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg' alt='no image'/>
//             <p>Join millions of Indians who trust and love TheFinMaster.</p>
//             <div className='text-center'>
//             <button className="bg-green-500 text-white px-4 py-2 rounded mt-4 ">Explore Products</button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

const GratuityCalculator = () => {
  const [salary, setSalary] = useState(60000);
  const [yearsOfService, setYearsOfService] = useState(20);
  const [gratuity, setGratuity] = useState(0);

  const calculateGratuity = () => {
    const calculatedGratuity = (salary * 15 * yearsOfService) / 26;
    setGratuity(calculatedGratuity.toFixed(2));
  };

  const handleSalaryChange = (e) => {
    const value = e.target.value === '' ? 0 : parseInt(e.target.value);
    setSalary(value);
  };

  const handleYearsOfServiceChange = (e) => {
    const value = e.target.value === '' ? 0 : parseInt(e.target.value);
    setYearsOfService(value);
  };

function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
      {
        question: 'What is the minimum service period required for gratuity?',
        answer: 'An employee must complete 5 years of continuous service to be eligible for gratuity, except in cases of death or permanent disability.',
      },
      {
        question: 'Is gratuity applicable to private company employees?',
        answer: 'Yes, gratuity is applicable if the company employs 10 or more people on any day in the preceding 12 months.',
      },
      {
        question: 'Is my entire salary considered for gratuity calculation?',
        answer: 'No, only your basic salary and dearness allowance (DA) are considered for calculating gratuity.',
      },
      {
        question: 'Can I receive gratuity if I resign before completing 5 years?',
        answer: 'Generally, no. However, in the event of death or permanent disability, the 5-year condition is waived.',
      },
      {
        question: 'Is gratuity taxable?',
        answer: 'Gratuity is tax-free up to ₹20 lakhs for non-government employees under current income tax rules.',
      },
      {
        question: 'How is gratuity calculated for more than 6 months in a year?',
        answer: 'If the final year of service exceeds 6 months, it is rounded up and considered a full year for calculation.',
      },
      {
        question: 'Can contractual employees receive gratuity?',
        answer: 'Yes, if they are employed directly by the company and are on its payroll.',
      },
      {
        question: 'What happens to gratuity if an employee dies during service?',
        answer: 'The legal heir or nominee is entitled to receive the gratuity, regardless of the employee length of service.',
      },
      {
        question: 'Can gratuity be forfeited?',
        answer: 'Yes, gratuity can be partially or fully forfeited in cases of proven misconduct, theft, or fraud.',
      },
      {
        question: 'Do startups offer gratuity?',
        answer: 'Yes, startups with 10 or more employees are legally required to offer gratuity if other eligibility criteria are met.',
      },
      {
        question: 'Is there a maximum limit for gratuity?',
        answer: 'Yes, the maximum tax-free gratuity amount is ₹20 lakhs. Employers may pay more, but the excess is taxable.',
      },
      {
        question: 'Can I calculate gratuity if I worked for multiple companies?',
        answer: 'Gratuity is calculated per employer. You need to complete 5 years of service with each employer to qualify.',
      },
      {
        question: 'Does leave encashment affect gratuity?',
        answer: 'No, leave encashment is a separate component and does not impact gratuity calculation.',
      },
      {
        question: 'Will future inflation affect gratuity amount?',
        answer: 'No, gratuity is calculated based on your last drawn salary, not future inflation or expected salary hikes.',
      },
      {
        question: 'Can I negotiate gratuity at the time of joining?',
        answer: 'No, gratuity is a statutory benefit mandated by law and not open to negotiation during hiring.'
      },
    ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>Gratuity Calculator – Calculate Gratuity Amount Online</title>
        <meta  name='description' content='Use our gratuity calculator to estimate your gratuity payout as per Indian labor laws. Fast and easy.'/>
        <meta name='keywords' content='gratuity calculator, retirement gratuity calculation formula, calculation of gratuity for central government employees, calculation of gratuity for private employees, dcrg calculation' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/gratuity-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Gratuity Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
          <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
<div className='py-4 '>


    <div className="container mx-auto p-4 max-w-7xl  ">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-2/3 px-4">
         
          <div className="bg-white  p-6 shadow-md rounded-md">
          <h1 className="text-2xl font-bold mb-4">Gratuity Calculator</h1>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Monthly salary (Basic + DA)</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  value={salary}
                  onChange={handleSalaryChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">₹ {salary.toLocaleString()}</span>
              </div>
              <input
                type="range"
                min="0"
                max="1000000"
                value={salary}
                onChange={(e) => setSalary(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Years of service</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="50"
                  value={yearsOfService}
                  onChange={handleYearsOfServiceChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{yearsOfService} years</span>
              </div>
              <input
                type="range"
                min="0"
                max="50"
                value={yearsOfService}
                onChange={(e) => setYearsOfService(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            
            {/* Calculate Button */}
            <div className="mb-6 ">
              <button
                onClick={calculateGratuity}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Calculate
              </button>
            </div>

            <div className="mt-4 text-center">
              <h2 className="text-xl font-bold">Total Gratuity payable</h2>
              <p className="text-3xl text-gray-800">₹ {gratuity.toLocaleString()}</p>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/3 px-6 mt-8 lg:mt-0 text-center">
          <div className="bg-white p-6 shadow-md rounded-md">
            <h2 className="text-xl font-bold mb-4 text-center">Invest the way you want</h2>
            <img src='https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg' alt='no image'/>
            <p>Join millions of Indians who trust and love TheFinMaster.</p>
            <div className='text-center'>
            <button className="bg-green-500 text-white px-4 py-2 rounded mt-4 ">Explore Products</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
    <div className="w-full md:w-2/3 p-4 mx-auto">
    <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is Gratuity?
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Gratuity is a lump sum amount paid by an employer to an employee as a token of appreciation for long-term service. It serves as a form of retirement benefit and is usually paid when an employee resigns, retires, or is laid off, provided the minimum service tenure requirement is met. The amount is governed by a specific formula under the Payment of Gratuity Act, which considers your last drawn salary and length of service.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Gratuity Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A gratuity calculator is an online tool that helps employees estimate the lump sum amount they are entitled to receive from their employer as a token of appreciation for long-term service. As per the Payment of Gratuity Act, 1972, gratuity is payable to employees who have completed at least five years of continuous service with the same employer.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator uses a standardized formula based on your last drawn basic salary, dearness allowance (if applicable), and total years of service to compute the gratuity amount. This eliminates the need for manual calculations, offering accurate and instant results. The gratuity calculator is especially helpful for employees planning their financial future, considering a job switch, or nearing retirement.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using a gratuity calculator ensures transparency and empowers you with the knowledge of your rightful benefits — helping you take proactive control of your post-employment finances.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why You Should Care About Gratuity
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding your gratuity entitlement is more than just knowing a number; it’s about being proactive with your financial planning. Whether you're planning to switch jobs, retire early, or simply understand your benefits better, knowing your gratuity helps you:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Anticipate post-employment income</li>
              <li>Plan for future investments</li>
              <li>Make informed decisions about retirement</li>
              <li>Ensure you're not under-compensated</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using TheFinMaster's Gratuity Calculator
            </h2>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Effortless Calculations</strong><br />No more manual math or hunting for complicated formulas. With just a few inputs, the calculator instantly provides an accurate estimate of your gratuity.</li>
              <li><strong>Informed Financial Decisions</strong><br />Knowing your gratuity amount can help you factor it into your retirement planning, emergency funds, or future investments.</li>
              <li><strong>Time-Saving</strong><br />The calculator delivers results in seconds, helping you avoid paperwork and miscalculations.</li>
              <li><strong>Easy to Use</strong><br />Designed for everyone, regardless of financial knowledge. Just enter basic details and get your estimate—no jargon, no confusion.</li>
              <li><strong>Available Anytime, Anywhere</strong><br />Access the calculator on your mobile, tablet, or desktop, 24x7. Plan your future on your terms.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How the Gratuity Calculator Works
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s calculator is straightforward. Here’s what you need to enter:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Last Drawn Basic Salary + Dearness Allowance (DA):</strong> This is the base used to compute your gratuity.</li>
              <li><strong>Years of Completed Service:</strong> Only full years are considered. If you’ve completed 5 years and 7 months, it will usually count as 6 years.</li>
              <li><strong>Type of Organization:</strong> Whether your employer is covered under the Gratuity Act or not (most are).</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Formula Used (As per Gratuity Act):</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Gratuity = (15/26) × Last Drawn Salary × Number of Completed Years of Service
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Here, 15/26 represents 15 days’ salary for every year of service based on a 26-day working month.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Who is Eligible for Gratuity?
            </h2>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Any employee who has completed 5 or more years of continuous service with an organization</li>
              <li>Both private and public sector employees</li>
              <li>Contractual employees are also eligible if they’re on the company’s payroll</li>
              <li>Eligibility may differ slightly if the organization isn’t covered under the Gratuity Act, but most structured companies follow it</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Example Scenario
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Meet Priya:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Last drawn basic salary + DA: ₹50,000</li>
              <li>Years of service: 7</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Gratuity = (15/26) × 50,000 × 7 = ₹2,01,923
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              So, Priya is likely to receive ₹2.01 lakhs as gratuity when she exits the organization, assuming it follows the Gratuity Act.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Tax Implications on Gratuity
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Gratuity is partially or fully tax-exempt depending on your employment type:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>For government employees:</strong> Entire gratuity is tax-free</li>
              <li><strong>For private sector employees covered under the Gratuity Act:</strong> Tax-free up to ₹20 lakhs</li>
              <li><strong>For those not covered under the Act:</strong> Tax exemption is calculated using a separate method but usually caps at ₹20 lakhs</li>
              <li>Any amount received above the tax-free limit is added to your income and taxed according to your income slab.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Things to Remember
            </h2>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>If you resign before completing 5 years, you're generally not eligible</li>
              <li>In case of death or disability, gratuity is paid even before 5 years</li>
              <li>Gratuity is based on basic salary + DA, not full CTC</li>
              <li>It’s a one-time payment and not a recurring benefit</li>
            </ul>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Additional Resources to Help You
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              TheFinMaster is more than just a calculator. We offer guides, blogs, and tools to help you:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Understand employee benefits</li>
              <li>Plan your retirement corpus</li>
              <li>Make tax-efficient decisions</li>
              <li>Navigate job transitions with confidence</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Ready to Estimate Your Gratuity?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Don’t wait until your last day to know your worth. Use TheFinMaster’s free gratuity calculator to find out what you're entitled to. Get a quick estimate, gain clarity, and start planning your next move with confidence.
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                          {/* Ad Banner */}
                      <div className="mt-4">
                        <div className="bg-white shadow-md rounded-lg overflow-hidden">
                          <div className="p-3 w-full h-auto rounded-md object-cover">
                            <AdBanner displayOrder="2" />
                          </div>
                        </div>
                      </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default GratuityCalculator;
